import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { withStyles } from '@material-ui/styles';

const styles = {
  root: {
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    background: '#FFF',
    opacity: '.5',
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
};

const CustomSpinnerLoader = ({ classes }) => {
  return (
    <div className={classes.root}>
      <CircularProgress />
    </div>
  );
};

export default withStyles(styles)(CustomSpinnerLoader);
